export const TOAST_STATE = {
    success: 'success-toast',
    warning: 'warning-toast',
    danger: 'danger-toast'
};

export type ToastState = (typeof TOAST_STATE)[keyof typeof TOAST_STATE];
